
  import {Component, Prop, Ref, Vue} from "vue-property-decorator";
  import RejectDialog from "@/components/RejectDialog/index.vue";
  import {AuditUserLogStatus, AuditUserLogType, ReimbursementDto} from "@/api/appService";
  import api from "@/api";
  import AgileAuditTag from "@/components/AgileAuditTag/index.vue";

  interface IAuditDto {
    auditFlowId: string;
    auditStatus?: number;
    id: string | number;
  }

  interface IAuditHostTypeGet{
    getHostType(rowItemDto:any):AuditUserLogType;
  }

  @Component({
    name: 'AuditTabPane', components: {
      RejectDialog, AgileAuditTag
    }
  })
  export default class AuditTabPane extends Vue {

    @Ref() rejectDialog!: RejectDialog;
    @Ref() backDialog!: RejectDialog;

    @Prop({required:false,default:false})
    hasDetailButton!:boolean;

    @Prop({required: true})
    fetchDataFunction!: Function;

    @Prop({required: true})
    auditFunction!: Function;


    @Prop({required: true})
    hostTypeGetter!: IAuditHostTypeGet;

    loading = true;

    tableItems: [] = [];
    currentAuditItem?: IAuditDto;

    submitting = false;

    private _hostType!:AuditUserLogType;

    created() {
      this.fetchData();
    }


    fetchData() {
      this.loading = true;
      const promise = this.fetchDataFunction.call(this).call(this,{maxResultCount:100});
      promise.then((res: any) => {
        this.tableItems = (res as any).items!;
        this.loading = false;

        this.$emit('count-changed',this.tableItems.length)
      })
    }

    handleViewDetail(itemDto:IAuditDto){
      this.$emit('open-detail',itemDto);
    }


    handlePass(itemDto: IAuditDto) {
      this.currentAuditItem = itemDto;
      this._hostType = (this.hostTypeGetter as any)(this.currentAuditItem);;
      console.log(itemDto);
      const body = {
        hostId: `${itemDto.id}`,
        hostType: this._hostType,
        auditFlowId: itemDto.auditFlowId,
        auditStatus: itemDto.auditStatus,
        status: AuditUserLogStatus.Pass,
        desc: `${this.$store.getters['user/name']} 通过了审核`
      };

      this.submitting = true;



      this.auditFunction.call(this).call(this,{body: body}).then((res: any) => {
        this.submitting = false;
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.fetchData();
      }).catch(()=>{
        this.submitting = false;
      });
    }

    async handleReject(itemDto: IAuditDto) {
      this.currentAuditItem = itemDto;

      this._hostType = (this.hostTypeGetter as any)(this.currentAuditItem);;
      (this.rejectDialog as any).show = true;
    }

    async handleBack(itemDto: IAuditDto) {
      this.currentAuditItem = itemDto;
      this._hostType =(this.hostTypeGetter as any)(this.currentAuditItem);;
      (this.backDialog as any).show = true;
    }


    rejected(rejectText: string) {
      const body = {
        hostId: `${this.currentAuditItem!.id}`,
        hostType: this._hostType,
        auditFlowId: this.currentAuditItem!.auditFlowId,
        auditStatus: this.currentAuditItem!.auditStatus,
        status: AuditUserLogStatus.Reject,
        desc: rejectText
      }

      this.submitting = true;
      this.auditFunction.call(this).call(this,{body: body}).then(() => {
        this.fetchData();
        this.$message.success('更新完成')
        this.submitting = false;
      }).catch(()=>{
        this.submitting = false;
      });

    }


    backed(text: string) {
      const body = {
        hostId: `${this.currentAuditItem!.id}`,
        hostType: this._hostType,
        auditFlowId: this.currentAuditItem!.auditFlowId,
        auditStatus: this.currentAuditItem!.auditStatus,
        status: AuditUserLogStatus.Back,
        desc: text
      }

      this.auditFunction.call(this).call(this,{body: body}).then(() => {
        this.fetchData();
        this.$message.success('更新完成')
      });
    }


  }
